/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/** Translation keys for the PickupInfoComponent */
export const pickupInfo = {
  inStorePickup: 'Retirada na loja',
  pickupBy: 'Recolha em',
  pickupFrom: 'Recolha em',
};

/** Translation keys for the PickupOptionDialogComponent */
export const pickupOptionDialog = {
  close: 'Fechar',
  modalHeader: 'Retirada na loja',
};

/** Translation keys for the PickupOptionsComponent */
const pickupOptions = {
  changeStore: 'Alterar loja',
  delivery: 'Envio (devolução gratuita)',
  pickup: 'Retirada gratuita na loja',
  selectStore: 'Selecione Loja',
};

/** Translation keys for the SetPreferredStoreComponent */
export const setPreferredStore = {
  makeThisMyStore: 'Faça desta minha loja',
  myStore: 'Minha Loja',
};

/** Translation keys for the StoreComponent */
export const store = {
  pickupFromHere: 'Pick up a partir daqui',
  stockLevel_inStock: '{{ count }} Em stock',
  stockLevel_outOfStock: 'Sem stock',
  viewHours: 'Ver Programação',
};

/** Translation keys for the StoreListComponent */
export const storeList = {
  noStoresMessage: 'Nenhuma loja encontrada no banco de dados...',
};

/** Translation keys for the StoreScheduleComponent */
export const storeSchedule = {
  closed: 'Fechard',
  storeHours: 'Horário de funcionamento da loja',
};

/** Translation keys for the StoreSearchComponent */
export const storeSearch = {
  findAStore: 'Encontre uma loja',
  findStores: 'Encontre lojas',
  hideOutOfStockOptions: 'Ocultar opções de ações',
  searchPlaceholder: 'Digite o CEP, a cidade ou o endereço',
  useMyLocation: 'Usar minha localização',
};
/** Translation keys for the AddressBook PickupInStoreComponent */

export const addressBookPickupInStore = {
  heading: 'Loja de Coleção',
};

/** Translation keys for Preferred Store on Store Finder Page */

export const storeFinderPickupInStore = {
  heading: 'Minha Loja',
};

/** Translation keys for Pickup In Store In Checkout */

export const checkoutPickupInStore = {
  heading: 'Itens para pegar',
  storeArtigoHeading: 'Endereço da loja de retirada',
};

export const cartArtigos = {
  item: 'Artigo',
};

export const deliveryPointOfServiceDetails = {
  itemsToBePickUp: 'Artigos Para Ser Pick-Up',
  pickUpInStoreAddress: 'Endereço da loja de retirada',
  itemsToBeShipped: 'Artigos a enviar',
  shippingAddress: 'Endereço de entrega',
  deliveryMethod: 'Método de entrega',
  statusDisplay_cancelled: 'Anulado',
  statusDisplay_cancelling: 'Cancelar pendente',
  statusDisplay_completed: 'Concluído',
  statusDisplay_created: 'Criado',
  statusDisplay_error: 'Brinco',
  statusDisplay_Error: 'Brinco',
  statusDisplay_processing: 'Brinco',
  statusDisplay_open: 'Abrir',
  statusDisplay_pending: {
    approval: 'Aprovação Brinco',
    merchant: {
      approval: 'Aprovação do comerciante Brinco',
    },
  },
  statusDisplay_approved: 'Aprovado',
  statusDisplay_rejected: 'Indeferido',
  statusDisplay_merchant: {
    approved: 'Merchant Aprovado',
    rejected: 'Comerciante Indeferido',
  },
  statusDisplay_assigned: {
    admin: 'Atribuído ao administrador',
  },
};

/** All the translation chunks for pickup in store. */
export const pickupInStore = {
  pickupInfo,
  pickupOptionDialog,
  pickupOptions,
  setPreferredStore,
  store,
  storeList,
  storeSchedule,
  storeSearch,
  addressBookPickupInStore,
  storeFinderPickupInStore,
  checkoutPickupInStore,
  cartArtigos,
  deliveryPointOfServiceDetails,
};
